/* eslint-disable no-else-return */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../../i18n/router';
import { useAppStore } from '../../../store/AppContext';
import IconCerdito from '../../../Icons/IconCerdito';
import IconCalendarioTarjeta from '../../../Icons/IconCalendarioTarjeta';
import IconPorcentaje from '../../../Icons/IconPorcentaje';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAuthStore } from '../../../store/AuthContext';
import { WaEventConponentFactory } from '../../TarjetasOro/wa-buttons/WaEventConponentFactory';
import { WaEventsConstants } from '../../TarjetasOro/wa-buttons/WaEventsConstants';
import { BackMappings } from '../../../utils/BackMappings';

const SolicitarTarjetaOro: FC = () => {
  const { t } = useTranslation();
  const waEventConponentFactory = new WaEventConponentFactory(t);

  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const fromApp = dataUser.user.isApp === 'false' ? 'web' : 'app_club';
  if (
    dataUser.user.isGibraltar ||
    dataUser.user.isEmpresa ||
    dataUser.user.isImpagosOr3x12
  ) {
    return <></>;
  } else {
    const solicitarTarjetaOro = () => {
      StorageHelper.setSolicitudOroOrigin(BackMappings.TARJETA_CTA_ORO);
      StorageHelper.removeOpenFormOro();
      window.location.href = routerLoader.LoadRouterByPath(
        'tarjeta-oro',
        dataApp.lang,
      );
    };

    const solicitarTarjetaOroOpenForm = () => {
      const label_button = t('tarjetas.tarjeta-socio.to-request');
      const title_button = t('tarjetas.tarjeta-socio.save-porcent');
      StorageHelper.setOpenFormOro();
      StorageHelper.loadOroDataEvent(
        BackMappings.TARJETA_CTA_ORO,
        title_button,
        label_button,
      );
      window.location.href = routerLoader.LoadRouterByPath(
        'tarjeta-oro',
        dataApp.lang,
      );
    };

    return (
      <>
        <div className="bloque-tarjeta bloque-tarjeta__oro">
          <p className="etiqueta oro">
            {' '}
            {t('tarjetas.tarjeta-socio.gold-card')}
          </p>
          <div className="bloque-tarjeta__contenido">
            <div className="img">
              <img
                src="../../assets/images/img-oro.png"
                alt="Colage de imagenes"
              />
            </div>

            <div className="bloque-tarjeta__content">
              <p className="title__medium u-margin-bottom-small">
                {t('tarjetas.tarjeta-socio.save-porcent')}
              </p>
              <p className="u-margin-bottom-small">
                {t('tarjetas.tarjeta-socio.save-what')}
              </p>

              <ul className="lista-ventajas">
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconCerdito />
                  </div>
                  <span> {t('tarjetas.tarjeta-socio.free')}</span>
                </li>
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconCalendarioTarjeta />
                  </div>
                  <span>{t('tarjetas.tarjeta-socio.no-engagement')}</span>
                </li>
                <li className="lista-ventajas__item">
                  <div className="icon">
                    <IconPorcentaje classCss="fill-oro" />
                  </div>
                  <span>{t('tarjetas.tarjeta-socio.cumulative')}</span>
                </li>
              </ul>

              <div className="botonera">
                <button
                  type="button"
                  onClick={solicitarTarjetaOro}
                  className="btn btn-secundary btn-secundary__oro"
                >
                  {t('tarjetas.tarjeta-socio.more-info')}
                </button>
                {(() => {
                  return waEventConponentFactory.getComponent(
                    WaEventsConstants.ORO,
                    solicitarTarjetaOroOpenForm,
                  );
                })()}
              </div>
            </div>
          </div>
          <p className="legal">
            {`${t('tarjetas.tarjeta-socio.block-min-text-one')} `}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                'link.condiciones-oro',
              )}?fromApp=${fromApp}`}
              className="link"
            >
              {t('tarjetas.tarjeta-socio.here')}
            </a>
          </p>
        </div>
      </>
    );
  }
};

export default SolicitarTarjetaOro;
